module.exports = __webpack_public_path__ + "static/media/lauder_1.522354b3.jpg";